import { enableLogging } from "mobx-logger";

import i18n from "i18next";
import Backend from "i18next-http-backend";
import { initReactI18next } from "react-i18next";
import { init as SentryInit } from "@sentry/react";

import { getStorage } from "../utils/storage";
import { useStore } from "../store";
import config from "./index";

const AppConfig = () => {
  const {
    appStore: { onErrorUnknown, onInitApp },
  } = useStore();

  const { search } = window.location;
  const query = search ? search.substr(1) : getStorage("kine_app");

  // init i18n -> app
  i18n
    .use(Backend)
    .use(initReactI18next)
    .init({
      lng: "en",
      fallbackLng: "en",
      initImmediate: false,
      backend: {
        loadPath: `/translation.json`,
      },
    })
    .then(() => {
      if (!query) throw new Error('no have a query');
      onInitApp(query);
    })
    .catch(onErrorUnknown);

  if (config.env === "production") return null;

  enableLogging({ action: true });

  // sentry
  SentryInit({
    dsn:
      "https://4f634872ede546ca96c464df8e93a8bd@o545583.ingest.sentry.io/5667793",
    release: `${config.baseUrl}_${config.version}`,
  });
};

export default AppConfig;
